import {get, writable} from "svelte/store";
import {actualiza, cargaUno, crea} from '../Api/sedes';

const estadoInicial = {
  cargando: true,
  error: null,
  sede: {}
};

const store = writable(estadoInicial);

export default {
  subscribe: store.subscribe,
  cargar: (id) => {
    const timeout = setTimeout(() => store.update(valor => ({...valor, cargando: true})), 300);

    store.update(() => estadoInicial);

    cargaUno(id)
        .then(sede => store.update(valor => ({...valor, sede})))
        .catch(e => store.update(valor => ({...valor, error: e})))
        .finally(() => {
          clearTimeout(timeout);
          store.update(valor => ({...valor, cargando: false}));
        });
  },
  actualizaCampo: (campo, valor) => {
    store.update(estado => ({
      ...estado,
      sede: {...estado.sede, [campo]: valor}
    }));
  },
  guarda() {
    const sede = get(store).sede;

    const promesa = sede.id ? actualiza(sede) : crea(sede);
    return promesa
        .then(sede => store.update(valor => ({...valor, error: false, sede})))
        .catch(error => store.update(valor => ({...valor, error})));
  },
  nueva() {
    store.set({
      cargando: false,
      error: null,
      sede: {
        nombre: ''
      }
    });
  }
}